// extracted by mini-css-extract-plugin
export default {"mainButton":"MainButton_mainButton__qc2Fk","mainLoadingButton":"MainButton_mainLoadingButton__Q23NZ"};